<template>
  <div class="Header">
    <div class="Title">
      <h1 v-text="$t('dashboard.summary')" />
      <h2>{{ title }}</h2>
    </div>
    <DateFilter
      class="DateFilter"
      :option="option"
      :date="date"
      @dateChange="handleDateChange"
    />
  </div>
</template>

<script>
import { DateFilter } from '@/components';
import { LAST_SEVEN_DAYS } from '@/constants';
import { getLastSevenDays } from '@/utils/calculateDate';

export default {
  name: 'Header',
  components: {
    DateFilter,
  },
  data() {
    return {
      date: getLastSevenDays(),
      option: LAST_SEVEN_DAYS,
    };
  },
  methods: {
    handleDateChange({ newDate, newOption }) {
      this.date = newDate;
      this.option = newOption;
    },
  },
  props: {
    title: {
      type: String,
      required: true,
      default: 'title',
    },
  },
};
</script>
<style lang="scss">
.Header {
  @include BasicHeader;
  .Title {
    margin-left: rem(50);
  }
  .DateFilter {
    margin-right: rem(50);
  }
}
</style>
